import { css } from '@emotion/react';
import {
  millisecondsToSeconds, motion,
} from 'motion/react';
import { type FC } from 'react';
import { useSlidingAnimationMsDuration } from '~/store/frontendState/graphicSettings/graphicSettings.selectors';
import { MapFilterComponent } from '../filter/mapFilter.component';
import { type MapSearchFilterBy } from '../filter/mapSearchFilterBy.enum';
import { type SearchItem } from './mapSearch.helpers';

const wrapperStyle = css({
  maxWidth: 610,
  width: '80%',
  height: 48,
  lineHeight: '48px',
  borderRadius: 4,
  textAlign: 'center',
});

const mobileWrapperStyle = css({
  width: 'calc(100% - 10px) !important',
  height: 48,
  lineHeight: '48px',
  borderRadius: 4,
  textAlign: 'center',
  left: '5px !important',
  top: '5px !important',
  transform: 'translate(0%) !important',
});

type MapSearchProps = Readonly<{
  areSearchSuggestsLoading: boolean;
  className?: string;
  filterBy: MapSearchFilterBy | null;
  isMobileScreen: boolean;
  searchSuggests: SearchItem[];
  searchText: string;

  onCloseSearchBar?: () => void;
  onSearchSuggestSubmit: (suggest: SearchItem) => void;
  onSetFilterBy?: (filterBy: MapSearchFilterBy) => void;
  onSetMapSearchText: (text: string) => void;
  onShowConfig?: () => void;
}>;

export const MapSearchComponent: FC<MapSearchProps> = (props) => {
  const { onSetMapSearchText, filterBy, onSetFilterBy } = props;

  const slidingAnimationDuration = millisecondsToSeconds(useSlidingAnimationMsDuration());

  return (
    <motion.div
      initial={{
        width: 0,
      }}
      animate={{
        width: '100%',
      }}
      transition={{ duration: slidingAnimationDuration }}
      css={props.isMobileScreen ? mobileWrapperStyle : wrapperStyle}
      className={props.className}
    >
      <MapFilterComponent
        filterBy={filterBy}
        searchText={props.searchText}
        onFilterByChange={onSetFilterBy}
        onSearchTextChange={onSetMapSearchText}
        onShowConfig={props.onShowConfig}
        searchSuggests={props.searchSuggests}
        onSearchSuggestSubmit={props.onSearchSuggestSubmit}
        areSearchSuggestsLoading={props.areSearchSuggestsLoading}
        isMobileScreen={props.isMobileScreen}
        onCloseSearchBar={props.onCloseSearchBar}
      />
    </motion.div>
  );
};
